<template>
  <div class="overview">
    <div v-if="attributes && monitors">
      <div class="overview__header">
        <div class="overview__hero" :style="heroStyle">
          <h1>{{ attributes.title }}</h1>
        </div>
      </div>
      <p class="overview__about" v-html="attributes.about"></p>
      <AllServices :monitors="monitors"></AllServices>
      <MonitorRow
        v-for="monitor in sortedMonitors"
        v-bind:key="monitor.id"
        :monitor="monitor"
      ></MonitorRow>
    </div>
    <div v-else>Loading...</div>
    <!-- <pre style="text-align: left">{{ statusData }}</pre> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"; // mapGetters
export default {
  mounted() {
    this.loadStatus(this.$route.params.slug);
  },
  methods: {
    ...mapActions({ loadStatus: "loadStatus" }),
  },
  computed: {
    ...mapGetters({
      attributes: "attributes",
      monitors: "monitors",
      statusData: "data",
    }),
    heroStyle() {
      return {
        "background-color": this.attributes.brandBackground,
        color: this.attributes.brandForeground,
      };
    },
    sortedMonitors() {
      const normalized = this.monitors.map((element) => {
        element.meta.name = element.meta.name
          ? element.meta.name
          : element.meta.attributes.name;
        return element;
      });
      return normalized.sort((a, b) =>
        a.meta.name > b.meta.name ? 1 : b.meta.name > a.meta.name ? -1 : 0
      );
    },
  },
  components: {
    AllServices: () => import("@/components/AllServices.vue"),
    MonitorRow: () => import("@/components/MonitorRow.vue"),
  },
};
</script>

<style lang="scss">
.overview {
  &__hero {
    padding: 3rem 0.5rem 1rem;
    h1 {
      margin: 0;
      padding: 0;
    }
  }
  &__about {
    padding: 0.5rem 0.5rem 1rem;
    line-height: 140%;
  }
  .monitor {
    margin-bottom: 1.5rem;
  }
}
</style>
